import { Injectable, computed, signal } from '@angular/core';

export enum FormMode {
  Add = 'add',
  Edit = 'edit',
  EditComplex = 'edit-complex',
  Show = 'show',
  Review = 'review',
}

@Injectable({
  providedIn: 'root',
})
export class FormModeService {
  readonly isShowMode = computed(() => this.state() === FormMode.Show);
  readonly isAddMode = computed(() => this.state() === FormMode.Add);
  readonly isEditMode = computed(() => this.state() === FormMode.Edit);

  readonly isEditComplexMode = computed(
    () => this.state() === FormMode.EditComplex,
  );

  readonly isReviewMode = computed(() => this.state() === FormMode.Review);
  readonly formMode = computed(() => this.state());

  private readonly state = signal(FormMode.Show);

  setFormMode(formMode: FormMode): void {
    this.state.set(formMode);
  }
}
